import {Utilities} from '@shared/utilities/utilities.model';
import {ClaimsAssociation, WorkingTypes} from './enums.model';


export const WORKING_TYPE_CONFIGURATION: string[] = [WorkingTypes.CARBODY, WorkingTypes.MECHANIC, WorkingTypes.ADMINISTRATION];

export class WorkingConfiguration {

	workingItemsByType: Map<WorkingTypes, WorkingConfigurationItem[]> = new Map();
	workingsCausalsTypes: Map<string, ClaimsAssociation> = new Map();
	commoditiesIdsByWorkingType: Map<WorkingTypes, string[]> = new Map();
	causalsByType: Map<WorkingTypes, string[]> = new Map<WorkingTypes, string[]>();

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			if (!Utilities.isVoid(model.working_type_map)) {
				WORKING_TYPE_CONFIGURATION.forEach(workingType => {
					if (!Utilities.isVoid(model.working_type_map[workingType].items)) {
						this.workingItemsByType.set(
							WorkingTypes[workingType],
							model.working_type_map[workingType].items.map(workingItem => new WorkingConfigurationItem(workingItem))
						);
						this.commoditiesIdsByWorkingType.set(
							WorkingTypes[workingType],
							model.working_type_map[workingType].commodities
						);

						this.causalsByType.set(WorkingTypes[workingType], model.working_type_map[workingType].causal_types);
					}
				});
			}

			if (!Utilities.isVoid(model.causal_type_list)) {
				Object.keys(model.causal_type_list).forEach(causal_type => this.workingsCausalsTypes.set(causal_type, model.causal_type_list[causal_type]));
			}
		}
	}
}

export class WorkingConfigurationItem {
	id: string;
	label: string;
	checked: boolean;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.id = model.id;
			this.label = model.label;
			this.checked = false;
		}
	}
}
